import styled from 'styled-components'

import { Label as DefaultLabel } from '../Shared'

export const Label = styled(DefaultLabel).attrs({
	as: 'legend',
})``
